export default __webpack_public_path__ + "static/media/landing-bg.98aa065f.png";